export const WAITING_TIME = 500;

export const ENTER_KEYCODE = 13;
export const TAB_KEYCODE = 9;
